var map = {
	"./badge_1.png": 9963,
	"./badge_2.png": 6144,
	"./badge_3.png": 2393,
	"./badge_4.png": 9974,
	"./badge_5.png": 1519,
	"./badge_L1.png": 3189,
	"./badge_L2.png": 5358,
	"./badge_L3.png": 4855,
	"./badge_L4.png": 2712,
	"./badge_L5.png": 3841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1783;